import { map, range } from 'lodash';
import tvtApi from '../services/tvt-api';
import { createEpisodeFilterOptionsLoader } from '../services/loaders';

export const SHOW_ERROR = 'SHOW_ERROR';
export const SHOW_REQUEST = 'SHOW_REQUEST';
export const SHOW_SUCCESS = 'SHOW_SUCCESS';
export const SHOW_SEASONS_SUCCESS = 'SHOW_SEASONS_SUCCESS';
export const SHOW_CHARACTERS_SUCCESS = 'SHOW_CHARACTERS_SUCCESS';
export const SET_EPISODE_OPTIONS_LOADER = 'SET_EPISODE_OPTIONS_LOADER';
export const TOGGLE_SEASON_OPTIONS_DISABLED = 'TOGGLE_SEASON_OPTIONS_DISABLED';

const requestShow = showId => ({
  type: SHOW_REQUEST,
  showId
});

export const loadShow = fetchedShow => ({
  type: SHOW_SUCCESS,
  fetchedShow
});

const errorShow = error => ({
  type: SHOW_ERROR,
  error
});

export const loadShowSeasons = seasonCount => {
  const seasons = map(range(1, seasonCount + 1), s => ({
    value: `${s}`,
    label: `Season ${s}`
  }));

  return {
    type: SHOW_SEASONS_SUCCESS,
    seasons
  };
};

export const getShowData = showId => async dispatch => {
  dispatch(requestShow(showId));

  try {
    const show = await tvtApi.getShowData(showId);
    dispatch(loadShow(show));
    dispatch(loadShowSeasons(show.number_of_seasons));
  } catch (err) {
    dispatch(errorShow(err));
  }
};

export const disableSeasonOptions = (
  isDisabled,
  episodes = [],
  updateEpisodes = false
) => ({
  type: TOGGLE_SEASON_OPTIONS_DISABLED,
  isDisabled,
  episodes,
  updateEpisodes
});

export const setEpisodeFilterOptions = ({
  showId,
  seasons,
  updateSeasons = false
}) => {
  const loader = createEpisodeFilterOptionsLoader({
    showId,
    seasons
  });
  return {
    type: SET_EPISODE_OPTIONS_LOADER,
    loader,
    seasons,
    updateSeasons
  };
};
